<template>
  <div
    id="reward-history"
    class="data-list-container vs-con-loading__container"
  >
    <!-- <vs-breadcrumb :items="items" class="mb-6"></vs-breadcrumb> -->
    <div class="vx-breadcrumb mb-6">
      <ul class="flex flex-wrap items-center">
        <li class="inline-flex items-end">
          <router-link to="/after-login">
            <feather-icon
              icon="HomeIcon"
              svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
            />
          </router-link>
          <span class="breadcrumb-separator mx-2 mr-1"
            ><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4"
          /></span>
        </li>
        <li class="inline-flex items-end">
          <router-link to="/reward" class="mb-1">
            <span class="breadcrumb-separator mx-2 mr-1 text-primary"
              >Reward</span
            >
          </router-link>
          <span class="breadcrumb-separator mx-2 mr-1"
            ><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4"
          /></span>
        </li>
        <li class="inline-flex items-end">
          <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color"
            >Reward History</span
          >
        </li>
      </ul>
    </div>
    <div slot="header" class="w-full flex justify-between flex-wrap-reverse mb-3">
      <div class="flex">
        <div class="con-input-search vs-table--search mr-4">
          <input type="text" class="input-search vs-table--search-input rounded-item border-custom" @keyup="searchItem" placeholder="Phone">
          <i class="vs-icon notranslate icon-scale material-icons null">search</i>
        </div>
        <datepicker placeholder="Select Date" class="reward-history-filter" v-model="date_filter" clear-button @closed="filterData" @cleared="filterData"></datepicker>
      </div>
      <vs-button class="gradient gradient-primary no-shadow px-4 py-3 export-btn" @click="exportRewardHistory">
        <img src="../../assets/images/excel.png" class="excel-icon mr-2" />
        Export
      </vs-button>
    </div>
    <vs-table mutiple :max-items="itemsPerPage" :data="rewardsHistoryList">
      <template slot="thead">
        <vs-th class="center-title text-center">#</vs-th>
        <vs-th class="text-center">Customer Name</vs-th>
        <vs-th class="text-center">Customer Phone</vs-th>
        <vs-th class="text-center">Reward Content</vs-th>
        <vs-th class="center-title text-center">Staff</vs-th>
        <vs-th class="center-title text-center">Total Price (USD)</vs-th>
        <vs-th class="center-title text-center">Discount (USD)</vs-th>
        <vs-th class="center-title text-center">Points</vs-th>
        <vs-th class="center-title text-center">Date</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="promotion-type font-medium truncate text-center">
                {{ indextr + 1 }}
              </p>
            </vs-td>
            <vs-td>
              <p class="promotion-type font-medium truncate">
                {{ tr.customer_name }}
              </p>
            </vs-td>
            <vs-td>
              <p class="promotion-type font-medium truncate">
                {{ StringHelper.phoneNumberFormat(tr.customer_phone) }}
              </p>
            </vs-td>
            <vs-td>
              <p class="promotion-type font-medium content-truncate">
                {{ tr.redeem_content }}
              </p>
            </vs-td>
            <vs-td>
              <p class="promotion-type font-medium truncate">
                {{ tr.staff_name }}
              </p>
            </vs-td>
            <vs-td>
              <p class="promotion-type font-medium truncate text-center">
                {{ tr.total_price }}
              </p>
            </vs-td>
            <vs-td>
              <p class="promotion-type font-medium truncate text-center">
                {{ tr.discount }}
              </p>
            </vs-td>
            <vs-td>
              <p class="promotion-type font-medium truncate text-center">
                {{ tr.lasted_point }}
              </p>
            </vs-td>
            <vs-td>
              <p class="promotion-type font-medium truncate text-center">
                {{ changeFormat(tr.created_at) }}
              </p>
              <p class="text-center">{{ getTime(tr.created_at) }}</p>
            </vs-td>
          </vs-tr>
          <vs-tr class="shadow-none bg-transparent">
            <vs-td>
              <p class="promotion-type font-medium truncate"></p>
            </vs-td>
            <vs-td>
              <p class="promotion-type font-medium truncate"></p>
            </vs-td>
            <vs-td>
              <p class="promotion-type font-medium truncate"></p>
            </vs-td>
            <vs-td>
              <p class="promotion-type font-medium truncate"></p>
            </vs-td>
            <vs-td
              class="bg-white rounded-item rounded-item-left border-y border-left"
            >
              <p
                class="promotion-type font-medium truncate text-center"
                style="text-transform: uppercase"
              >
                Total
              </p>
            </vs-td>
            <vs-td class="bg-white border-y">
              <p class="promotion-type font-medium truncate text-center">
                {{ totalPriceList() }}
              </p>
            </vs-td>
            <vs-td class="bg-white border-y">
              <p class="promotion-type font-medium truncate text-center">
                {{ totalDiscountList() }}
              </p>
            </vs-td>
            <vs-td class="bg-white border-y">
              <p class="promotion-type font-medium truncate text-center">
                {{ totalPointList() }}
              </p>
            </vs-td>
            <vs-td class="bg-white border-y border-right">
              <p class="promotion-type font-medium truncate"></p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <div v-if="rewardsHistoryData._meta.pageCount">
      <!-- <vs-pagination class="mt-6 custom-pagination" :total="parseInt(rewardsHistoryData._meta.pageCount)" v-model="currentPage" @click.native="changePage(currentPage, itemsPerPage)"></vs-pagination> -->
      <custom-pagination
        class="custom-pagination mt-6"
        :totalPages="parseInt(rewardsHistoryData._meta.pageCount)"
        :currentPage="currentPage"
        @pageChanged="changePage"
        :key="page_key"
      ></custom-pagination>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import {changeFormatHelper, formatExportDateString} from '../../helper/datetimeHelper';
import { StringHelper } from "../../models/string_helper";
// import axios from "axios";
import FileDownload from'js-file-download';
export default {
  components:{
    moment,
    Datepicker
  },
  data(){
    let format_export_date_string = formatExportDateString();
    return {
      currentPage: 1,
      itemsPerPage: 10,
      action_type: '',
      isOpenLoading: false,
      page_key: 0,
      StringHelper,
      format_export_date_string,
      date_filter: null,
      search: ''
    }
  },
  computed:{
    rewardsHistoryList(){
      return this.$store.state.rewardList.rewardHistoryList;
    },
    rewardsHistoryData(){
      return this.$store.state.rewardList.rewardHistoryData;
    }
  },
  methods: {
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#reward-history',
        scale: 0.8
      })
      if(this.loadTime){
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: this.action_type + ' reward history failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' reward history failed',
            acceptText: 'OK'
          })
        }
      }, 10000);

    },
    closeLoading() {
      this.$vs.loading.close('#reward-history > .con-vs-loading');
      this.isOpenLoading = false;
    },
    filterData() {
      this.currentPage = 1;
      let data = {
        page: this.currentPage,
        "per-page": this.itemsPerPage,
        customer_phone: this.search
      }
      if(this.date_filter) {
        data.filter_date = moment(this.date_filter).format('YYYY-MM-DD');
      }
      this.action_type = "Get list";
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("rewardList/GET_REWARD_HISTORY_LIST", data).then(() => {
        this.closeLoading();
      });
    },
    totalPriceList(){
      let totalPrice = 0;
      for(let i = 0;i<this.rewardsHistoryList.length;i++){
        totalPrice = totalPrice +  parseInt(this.rewardsHistoryList[i].total_price);
      }
      return totalPrice.toFixed(2);
    },
    totalDiscountList(){
      let totalDiscount = 0;
      for(let i = 0;i<this.rewardsHistoryList.length;i++){
        totalDiscount = totalDiscount +  parseInt(this.rewardsHistoryList[i].discount);
      }
      return totalDiscount;
    },
    totalPointList(){
      let totalPoint = 0;
      for(let i = 0;i<this.rewardsHistoryList.length;i++){
        totalPoint = totalPoint +  parseInt(this.rewardsHistoryList[i].lasted_point);
      }
      return totalPoint;
    },
    changePage(currentPage){
      const obj = {
          page: currentPage,
          "per-page": this.itemsPerPage,
          customer_phone: this.search
      }
      if(this.date_filter) {
        obj.filter_date = moment(this.date_filter).format('YYYY-MM-DD');
      }
      this.action_type = 'Get list';
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("rewardList/GET_REWARD_HISTORY_LIST", obj).then(() => {
        this.closeLoading();
        this.page_key++;
        this.currentPage = currentPage;
      })
    },
    changeFormat(date){
      if(date) {
        return changeFormatHelper(date);
      } else {
        return 'N/A';
      }
    },
    getTime(date) {
      if(date) {
        return moment(date).format('hh:mm A');
      } else {
        return '';
      }
    },
    exportRewardHistory() {
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.action_type = 'Export';

      this.$store.dispatch("rewardList/EXPORT_REWARD_HISTORY").then((res) => {
        FileDownload(res.data, `#${localStorage.getItem("domainId")}-reward-history-${moment().format(this.format_export_date_string)}.xls`);
        this.closeLoading();
        this.$vs.notify({
          title: "Notification",
          text: "Export Reward History Success",
          color: "success",
          position: "top-right"
        });
      });
    },
    searchItem({target}) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }

      this.timer = setTimeout(() => {
        this.search = target.value;
        this.currentPage = 1;
        const obj = {
          page: this.currentPage,
          "per-page": this.itemsPerPage,
          customer_phone: target.value,
        };
        if(this.date_filter) {
          obj.filter_date = moment(this.date_filter).format('YYYY-MM-DD');
        }
        this.action = "Get list";
        this.$store.dispatch('rewardList/GET_REWARD_HISTORY_LIST',obj).then(() => {
          this.closeLoading();
          this.page_key++;
        });
      }, 500);
    }
  },
  created() {
     const obj = {
      page: this.currentPage,
      "per-page": this.itemsPerPage
    }
    this.$store.dispatch("rewardList/GET_REWARD_HISTORY_LIST", obj)
  },
}
</script>
